export const CAT_NOT_FOUND = 'CAT_NOT_FOUND';
export const GET_BREEDS = 'GET_BREEDS';
export const GET_CAT = 'GET_CAT';
export const GET_CATS = 'GET_CATS';
export const RESET = 'RESET';
export const SET_LOADING = 'SET_LOADING';
